import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Detect environment
const isProductionCode = process.env.NODE_ENV === 'production';
const fallbackLanguage = 'en';

// Use local public folder path for translations
const localLoadPath = '/locales/{{lng}}/{{ns}}.json';

//const remoteLoadPath = 'http://localhost:5013/api/locales/{{lng}}.json';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("language"),
    fallbackLng: fallbackLanguage,
    debug: !isProductionCode,
    backend: {
      loadPath: localLoadPath, // <-- use public folder path
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    saveMissing: false, // disable auto-save if not using remote
  });

export default i18n;
